
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { ControladorSeccion } from './controlador';

    @Component( {
        name: "Componente",
        props: {},
        components: {}
    } )
    export default class Componente extends Vue
    {

        @Prop()
        public Controlador: ControladorSeccion;
        public get Buscador() { return this.Controlador.Buscador; }
        public get Filtros() { return this.Controlador.Buscador.Filtros; }
        public get Estado() { return this.Controlador.Buscador.Estado; }
        public get Items() { return this.Controlador.Buscador.Items; }
        public get Seleccionados() { return this.Controlador.Seleccionados; }

        public Abierto: boolean = false;

        Seleccionar( x: number )
        {
            this.Abierto = false;
            if ( this.Filtros.Valores.Tipo == x )
                return;
            this.Filtros.Valores.Tipo= x;
            this.Filtros.Valores.Cuenta = 0;
            this.Buscador.Buscar( 1 );
        }

        public Refresh: boolean = false;
        Refrescar()
        {
            this.Refresh = false;
            this.$nextTick( () => this.Refresh = true );
        }
    }
